import React, { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";
import CheckValue from "../../../../Utils/CheckValue/CheckValue";

export default function Bid({ symbol_id }) {
  const socket = useContext(SocketContext);
  const [bid, setBid] = useState(0);

  useEffect(() => {
    socket.emit("giverate", symbol_id);

    const tradeListener = (data) => {
      if (data !== null && typeof data.Bid !== "undefined") {
        setBid(data.Bid);
      }
    };

    socket.on(`trade${symbol_id}`, tradeListener);

    return () => {
      socket.off(`trade${symbol_id}`, tradeListener);
    };
  }, [socket, symbol_id]);

  return (
    <div className="menuBuyPrice addFlex">
      <CheckValue number={bid} extra={"AddFontSize"} />
    </div>
  );
}
